export default "__VITE_ASSET__B0P26w1O__"